import { supabase } from "@/integrations/supabase/client";
import { track } from "@/lib/posthog";

export type BillingInterval = "month" | "year";

/**
 * Starts a Stripe Checkout session for the Pro plan and returns the
 * hosted checkout URL. Callers are responsible for opening the URL
 * (typically `window.open(url, "_blank")`) and for busy/toast state.
 */
export async function startProCheckout(
  interval: BillingInterval,
  tier: "pro" | "ultra" = "pro",
  placement?: string,
): Promise<string> {
  track("checkout_started", { tier, interval, placement });
  try { sessionStorage.setItem("huelo_checkout_ctx", JSON.stringify({ tier, interval, placement })); } catch { /* ignore */ }
  const { data, error } = await supabase.functions.invoke<{ url: string; promoApplied?: boolean }>(
    "create-checkout",
    { body: { interval, tier, placement } },
  );
  if (error || !data?.url) {
    track("checkout_failed", { tier, interval, placement, error: error?.message ?? "no_url" });
    throw new Error(error?.message || "Couldn't start checkout");
  }
  track("checkout_redirected", { tier, interval, placement, promo_applied: !!data.promoApplied });
  return data.url;
}
